var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _mask, _rect2, _circle2, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.5891,
    y: 205.959,
    width: 387,
    height: 197,
    rx: 9,
    transform: "rotate(-15.185 37.5891 205.959)",
    fill: "#9F86C0",
    stroke: "black",
    strokeWidth: 14
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 258.784,
    cy: 240.949,
    r: 68.5,
    transform: "rotate(-15.185 258.784 240.949)",
    stroke: "black",
    strokeWidth: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.6775 254.807C81.3441 257.263 83.8758 258.714 86.3321 258.047C88.7884 257.38 90.2392 254.849 89.5725 252.392L80.6775 254.807ZM81.449 222.462L80.2419 218.014L71.3468 220.428L72.5539 224.876L81.449 222.462ZM89.5725 252.392L81.449 222.462L72.5539 224.876L80.6775 254.807L89.5725 252.392Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7938 219.22L71.346 220.426L73.7584 229.322L78.2062 228.116L75.7938 219.22ZM108.532 219.892C110.988 219.226 112.44 216.694 111.774 214.238C111.107 211.781 108.576 210.33 106.12 210.996L108.532 219.892ZM78.2062 228.116L108.532 219.892L106.12 210.996L75.7938 219.22L78.2062 228.116Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.623 331.998C100.956 329.542 102.407 327.01 104.863 326.343C107.32 325.677 109.851 327.128 110.518 329.584L101.623 331.998ZM118.641 359.515L119.849 363.962L110.953 366.376L109.746 361.929L118.641 359.515ZM110.518 329.584L118.641 359.515L109.746 361.929L101.623 331.998L110.518 329.584Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.403 365.17L110.956 366.378L108.54 357.483L112.987 356.275L115.403 365.17ZM143.31 348.039C145.766 347.372 148.298 348.822 148.965 351.278C149.632 353.734 148.182 356.266 145.726 356.933L143.31 348.039ZM112.987 356.275L143.31 348.039L145.726 356.933L115.403 365.17L112.987 356.275Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M397.838 168.725C398.505 171.181 397.054 173.713 394.598 174.379C392.141 175.046 389.61 173.595 388.943 171.139L397.838 168.725ZM380.82 141.208L379.612 136.761L388.507 134.346L389.715 138.794L380.82 141.208ZM388.943 171.139L380.82 141.208L389.715 138.794L397.838 168.725L388.943 171.139Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384.058 135.553L388.505 134.345L390.921 143.239L386.474 144.447L384.058 135.553ZM356.151 152.684C353.695 153.351 351.163 151.901 350.496 149.445C349.829 146.989 351.279 144.457 353.735 143.789L356.151 152.684ZM386.474 144.447L356.151 152.684L353.735 143.789L384.058 135.553L386.474 144.447Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M418.791 245.916C418.125 243.46 415.593 242.009 413.137 242.676C410.68 243.342 409.23 245.874 409.896 248.33L418.791 245.916ZM418.02 278.261L419.227 282.708L428.122 280.294L426.915 275.847L418.02 278.261ZM409.896 248.33L418.02 278.261L426.915 275.847L418.791 245.916L409.896 248.33Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M423.675 281.502L428.123 280.296L425.71 271.401L421.263 272.607L423.675 281.502ZM390.937 280.831C388.48 281.497 387.029 284.028 387.695 286.485C388.361 288.941 390.893 290.393 393.349 289.726L390.937 280.831ZM421.263 272.607L390.937 280.831L393.349 289.726L423.675 281.502L421.263 272.607Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.945 215.125L273.304 202.814L274.79 208.289L257.675 212.935C257.675 212.935 264.663 217.153 265.673 220.877L277.297 217.722L278.664 222.759L267.534 225.78C267.534 225.78 269.922 243.381 248.317 248.116L281.862 268.784L271.475 271.603L237.945 251.966L236.423 246.359C236.423 246.359 249.428 243.205 254.6 237.804C258.776 233.425 257.633 231.76 257.603 229.886C257.573 229.189 256.862 228.724 256.12 228.925L233.367 235.101L232 230.063L255.298 223.739C255.792 223.605 255.97 223.086 255.616 222.759C254.162 221.32 250.507 218.22 246.706 218.499C241.768 218.899 229.788 221.915 229.788 221.915L227.945 215.125Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_3210_2974",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 142,
    width: 412,
    height: 216.788,
    rx: 16.4389
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 142,
    width: 412,
    height: 216.788,
    rx: 16.4389,
    fill: "#B89DDC",
    stroke: "black",
    strokeWidth: 34,
    mask: "url(#path-12-inside-1_3210_2974)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.483,
    cy: 250.909,
    r: 66.5299,
    fill: "#DDC6FB",
    stroke: "black",
    strokeWidth: 19
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8984 211.568C75.8984 216.263 79.704 220.068 84.3984 220.068C89.0929 220.068 92.8984 216.263 92.8984 211.568H75.8984ZM92.8984 181.043V172.543H75.8984V181.043H92.8984ZM92.8984 211.568V181.043H75.8984V211.568H92.8984Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4002 172.543L75.9002 172.541L75.8967 189.541L84.3967 189.543L84.4002 172.543ZM115.323 189.549C120.018 189.55 123.824 185.746 123.825 181.051C123.826 176.357 120.021 172.55 115.327 172.549L115.323 189.549ZM84.3967 189.543L115.323 189.549L115.327 172.549L84.4002 172.543L84.3967 189.543Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8984 290.293C75.8984 285.599 79.704 281.793 84.3984 281.793C89.0929 281.793 92.8984 285.599 92.8984 290.293H75.8984ZM92.8984 320.818V329.318H75.8984V320.818H92.8984ZM92.8984 290.293V320.818H75.8984V290.293H92.8984Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4002 329.318L75.9002 329.32L75.8967 312.32L84.3967 312.318L84.4002 329.318ZM115.323 312.312C120.018 312.311 123.824 316.116 123.825 320.81C123.826 325.505 120.021 329.311 115.327 329.312L115.323 312.312ZM84.3967 312.318L115.323 312.312L115.327 329.312L84.4002 329.318L84.3967 312.318Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M407.281 211.568C407.281 216.263 403.476 220.068 398.781 220.068C394.087 220.068 390.281 216.263 390.281 211.568H407.281ZM390.281 181.043V172.543H407.281V181.043H390.281ZM390.281 211.568V181.043H407.281V211.568H390.281Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M398.779 172.543L407.279 172.541L407.283 189.541L398.783 189.543L398.779 172.543ZM367.856 189.549C363.162 189.55 359.356 185.746 359.355 181.051C359.354 176.357 363.158 172.55 367.853 172.549L367.856 189.549ZM398.783 189.543L367.856 189.549L367.853 172.549L398.779 172.543L398.783 189.543Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M407.281 290.293C407.281 285.599 403.476 281.793 398.781 281.793C394.087 281.793 390.281 285.599 390.281 290.293H407.281ZM390.281 320.818V329.318H407.281V320.818H390.281ZM390.281 290.293V320.818H407.281V290.293H390.281Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M398.779 329.318L407.279 329.32L407.283 312.32L398.783 312.318L398.779 329.318ZM367.856 312.312C363.162 312.311 359.356 316.116 359.355 320.81C359.354 325.505 363.158 329.311 367.853 329.312L367.856 312.312ZM398.783 312.318L367.856 312.312L367.853 329.312L398.779 329.318L398.783 312.318Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M213.859 217.002H262.149V222.831H243.928C243.928 222.831 249.721 228.894 249.721 232.859H262.095V238.221H250.247C250.247 238.221 247.877 256.316 225.181 255.197L252.881 284.718H241.822L213.859 256.223V250.254C213.859 250.254 227.604 250.626 234.186 246.663C239.505 243.445 238.82 241.486 239.294 239.62C239.452 238.921 238.872 238.268 238.082 238.268H213.859V232.905H238.662C239.188 232.905 239.505 232.438 239.242 232.019C238.188 230.2 235.397 226.142 231.553 225.396C226.55 224.464 213.859 224.23 213.859 224.23V217.002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/CMS.81cd62e5159b4a8f90770416e4293dc6.svg";
export { ForwardRef as ReactComponent };